module.exports = __webpack_public_path__ + "files/sql-server-2005.36bcf1da.pdf";